import { ArrowRight } from "lucide-react";
import { Link } from "@tanstack/react-router";

interface FeatureCrossLink {
  title: string;
  description: string;
  href: string;
}

interface FeatureCrossLinksProps {
  eyebrow?: string;
  headline: React.ReactNode;
  description?: React.ReactNode;
  links: FeatureCrossLink[];
}

const FeatureCrossLinks = ({
  eyebrow,
  headline,
  description,
  links,
}: FeatureCrossLinksProps) => {
  return (
    <section className="py-20 md:py-28 px-6 md:px-10">
      <div className="max-w-6xl mx-auto">
        {eyebrow && (
          <div className="flex items-center gap-4 text-xs uppercase tracking-[0.18em] text-muted-foreground mb-4">
            <span className="h-px w-8 bg-border" />
            <span>{eyebrow}</span>
          </div>
        )}
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-14">
          <h2
            className="text-4xl md:text-5xl tracking-tight"
            style={{ fontFamily: "var(--font-display)" }}
          >
            {headline}
          </h2>
          {description && (
            <p className="text-base md:text-lg text-muted-foreground max-w-md md:text-right">
              {description}
            </p>
          )}
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {links.map((link) => (
            <Link
              key={link.href}
              to={link.href}
              className="group rounded-xl border border-border bg-card/40 p-6 md:p-8 flex flex-col gap-3 transition-colors hover:border-foreground/30"
            >
              <h3 className="flex items-center justify-between text-lg font-medium text-foreground">
                {link.title}
                <ArrowRight className="h-4 w-4 shrink-0 text-muted-foreground transition-transform group-hover:translate-x-1" />
              </h3>
              <p className="text-sm md:text-base leading-relaxed text-muted-foreground">
                {link.description}
              </p>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FeatureCrossLinks;
